export default {
  toastQueueDelay: 250,
  defaultToastShowtime: 2000,
  defaultErrorToastShowtime: 4000,
}



// WEBPACK FOOTER //
// ./src/redux/sagas/saga-config.ts